module.exports = __webpack_public_path__ + "static/logo_white-baa3464c67c798b203eeadb3a4f7fd5d.svg";